import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from "@/api/auth";
import Layout from "@/layouts/";


function BuildNoLayout(path, name, views, title = '') {
  return {
    path: path,
    name: name,
    component: () => import("@/views" + views),
    meta: {
      title: title || name,
      layout: false
    }
  }
}

function BuildLayout(path, name, views, title = '') {
  return {
    path: "/",
    component: Layout,
    redirect: path,
    children: [{
      path: path.replace("/", ""),
      component: () => import("@/views" + views),
      name: name,
      meta: {
        title: title || name
      }
    }]
  }
}

Vue.use(VueRouter)

const routes = [
  BuildNoLayout("/payment", "Payment", "/payment/Card"),
  BuildNoLayout("/payment/success", "PaymentSuccess", "/payment/Success", "Payment successfull"),
  BuildNoLayout("/payment/secure", "PaymentSecure", "/payment/Secure", "Payment Secure"),
  BuildNoLayout("/authorization", "Login", "/auth/Login"),
  BuildNoLayout("/logout", "Logout", "/auth/Logout"),
  BuildNoLayout("/payment/make", "MakePayment", "/payment/MakePayment", "Make Payment"),
  BuildLayout("/invoice", "Invoice", "/invoice/Invoice"),
  BuildLayout("/dashboard", "Dashboard", "/dashboard/Dashboard"),
  BuildLayout("/transactions", "Transactions", "/transactions/Transactions"),
  BuildLayout("/profile", "Profile", "/user/Profile"),
  BuildLayout("/generate/url", "GenerateURL", "/generate/GenerateURL", "Generate URL"),
  BuildLayout("/user/manager", "UserManager", "/user/Manager", "User Manager"),
  BuildLayout("/account", "Account", "/account/Account"),
  BuildNoLayout("/error/404", "Error404", "/error/404", "404 Page not found"),
  BuildNoLayout("*", "Error404", "/error/404", "404 Page not found")
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

import user from "@/api/user";
import store from "@/store";
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Acquiere Card";
  let noAuth = ["Login", "Payment", "PaymentSuccess", "PaymentSecure", "Error404"]
  if (noAuth.indexOf(to.name) === -1 && !auth.getToken()) {
    return next({
      name: "Login"
    });
  }

  if (auth.getToken()) {
    user.getUser().then(res => {
      if (res && res["result"]) {
        store.state.user = res["data"];
        auth.setUser(JSON.stringify(res["data"]))
        next();
      }
    });
  }else{
    next()
  }

})


export default router